var _style, _defs, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPvFacilidades = function SvgPvFacilidades(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_2_);}\r\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 512,
    height: 512
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M493.7,375.5L437,318.8l-21.1,21.1l-32.2-32.2c21.3-26,32.8-58.3,32.8-92.4c0-39.1-15.2-75.9-42.9-103.5 c-0.2-0.2-0.5-0.4-0.7-0.7V0H5.2v512H373V339.4l21.7,21.7l-21.1,21.1l56.6,56.6c8.7,8.7,20.2,13.1,31.7,13.1 c11.5,0,23-4.4,31.7-13.1C511.1,421.4,511.1,393,493.7,375.5 M35.2,369.9L87,318.1l29.7,29.7l39.9-39.9c3.1,3.8,6.4,7.5,10,11 c27.6,27.6,64.4,42.9,103.5,42.9c26,0,50.9-6.7,72.8-19.3v60.1H35.2V369.9z M386.5,215.4c0,31.1-12.1,60.3-34.1,82.3 c-22,22-51.2,34.1-82.3,34.1c-31.1,0-60.3-12.1-82.3-34.1c-3.6-3.6-6.8-7.3-9.8-11.1l29.5-29.5l24.4,24.4l66.4-66.4v37.3h30v-89 h-89v30h38.3L232,239.1l-24.4-24.4l-45,45c-17.3-42.1-8.8-92.4,25.3-126.6c22.7-22.7,52.5-34,82.3-34c29.8,0,59.6,11.3,82.3,34 C374.4,155.1,386.5,184.3,386.5,215.4 M343,30v58.4c-55.9-32-128.6-24.2-176.3,23.5c-46,46-54.9,115.3-26.7,170.4l-23.2,23.2 L87,275.6l-51.8,51.8V30H343z M35.2,432.5H343V482H35.2V432.5z M472.5,417.7c-5.8,5.8-15.2,5.8-21,0L416,382.3l21-21l35.4,35.4 C478.2,402.5,478.2,411.9,472.5,417.7"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPvFacilidades, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pv-facilidades.3b9e8ee8.svg";
export { ForwardRef as ReactComponent };